export default {
  batch: {
    status: "状态",
    totalDistance: "总距离 (km)",
    productionEmission: "生产排放 (kg CO2e)",
    transportEmission: "运输排放 (kg CO2e)",
    totalEmission: "总排放 (kg CO2e)",
    tax: "税费 (€)",
    more: "更多",
    fallbackDistanceWarning: "使用备用方法计算的距离，可能存在误差",
  },
  label: {
    start: "起点",
    end: "终点",
    via: "途经点",
    mode: "运输方式",
    weight: "重量",
    cnCode: "CN编码",
  },
  placeholder: {
    start: "例如：上海，中国",
    end: "例如：鹿特丹，荷兰",
    via: "例如：新加坡，新加坡",
    mode: "运输方式",
    weight: "输入重量",
    cnCode: "例如：25070080 或 水泥",
    location: "例如：上海，中国",
  },
  action: {
    addVia: "添加途经点",
    remove: "移除",
    calculate: "计算",
    loadMore: "加载更多",
  },
  transport: {
    sea: "海运",
    road: "公路",
    rail: "铁路",
    barge: "驳船",
  },
  unit: {
    tonne: "吨",
    kilogram: "千克",
    pound: "磅",
  },
  leg: {
    enable_detailed_mode: "启用详细模式以查看排放因子值",
    detailed_mode: "详细模式",
    simple_mode: "简洁模式",
    origin: "起始地",
    destination: "目的地",
    transport_mode: "运输方式",
    distance: "距离 (km)",
    weight: "重量 (t)",
    cn_code: "CN编码",
    transport_emission: "运输排放 (kg CO2e)",
    transport_emission_factor: "运输排放因子",
    transport_emission_factor_id: "运输排放因子ID",
    production_emission: "生产排放 (kg CO2e)",
    production_emission_factor: "生产排放因子",
    production_emission_factor_id: "生产排放因子ID",
    total_emission: "总排放 (kg CO2e)",
  },
  error: {
    cnCodeSearchFailed: "CN编码搜索失败",
    cnCodeSearchFailedDesc: "无法查询可用的CN编码，请检查网络。",
    locationRequired: "请输入地点",
    modeRequired: "请选择运输方式",
    requiredFields: "请填写所有必填字段",
    calculationFailed: "计算失败",
    checkInputs: "请检查输入或稍后重试",
    cnCodeRequired: "请输入CN编码",
    weightRequired: "请输入重量",
    maxViaPoints: "最多允许3个途经点",
    cnCodeInvalid: "CN编码只能包含字母、数字和下划线，最多20个字符",
    weightPositive: "重量必须为正值",
    locationSearchFailed: "地点搜索失败",
    locationSearchFailedDesc: "无法连接到地点服务，请稍后重试。",
  },
  result: {
    title: "计算结果",
    selected: "所选方案",
    alternative: "推荐方案 ({mode})",
    leg: "路段 {index}",
    totalDistance: "总距离",
    productionEmission: "生产排放",
    transportEmission: "运输排放",
    totalEmission: "总排放",
    tax: "碳税",
  },
  page: {
    title: "CBAM排放计算器",
    single: "单次计算",
    batchTitle: "批量计算",
    batch: {
      rowNumber: "行号",
      cnCode: "CN编码",
      weight: "重量 (t)",
      originCity: "起始城市",
      originCoords: "起始坐标",
      destinationCity: "目的城市",
      destinationCoords: "目的坐标",
      transportMode: "运输方式",
      error: "错误",
      errorRowsDetected: "检测到 {count} 行错误数据，已自动排除。仅保存 {validCount} 行有效数据。",
      errors: {
        invalidCsvHeader: "CSV表头无效",
        headerMustBe: "表头必须为：{fields}",
        batchSizeExceed: "批量大小不能超过 {maxSize}",
        csvValidationFailed: "CSV验证失败",
        checkFormat: "请检查格式或重试",
        invalidXlsxFile: "XLSX文件无效",
        fileIsEmpty: "文件为空",
        invalidXlsxHeader: "XLSX表头无效",
        xlsxValidationFailed: "XLSX验证失败",
      },
    },
    upgradeTip: "升级到高级版，解锁分段重量和 CN 编码计算，提升 CBAM 合规精度！",
    learnMore: "了解更多",
    reportTitle: "排放报告",
    viewReport: "查看报告",
    totalOverview: "总体概览",
    origin: "起点",
    destination: "终点",
    totalDistance: "总距离",
    tax: "税费",
    basedOnEUR: "基于 €{amount}",
    productionEmission: "生产排放",
    transportEmission: "运输排放",
    totalEmission: "总排放",
    pleaseCalculateFirst: "请先进行计算",
    batchLimitInfo: "免费用户最多支持10条记录，付费用户最多支持200条记录。",
    clearErrorData: "清除错误数据",
    submitCalculation: "提交计算",
    confirmDeleteTask: "确定要删除此任务吗？",
    reupload: "重新上传",
    uploadHint: "点击或将文件拖拽到此区域上传",
    csvOnlyHint: "免费版只支持csv，付费用户支持csv和xlsx",
    configFailed: "配置获取失败，请重新获取配置",
    batchResultSummary: "共 {total} 条，成功 {success}，失败 {fail}",
    searchByCNCode: "按CN编码搜索",
    downloadCSVTemplate: "下载 CSV 模板",
    downloadXLSXTemplate: "下载 XLSX 模板",
    previewReport: "预览报告",
    to: "到",
    // 模板相关翻译
    template: {
      saveTemplate: "保存模板",
      templateName: "模板名称",
      namePlaceholder: "请输入模板名称",
      nameRequired: "请输入模板名称",
      nameTooLong: "模板名称不能超过50个字符",
      formIncomplete: "请先填写完整表单再保存模板",
      saveSuccess: "模板保存成功",
      saveFailed: "模板保存失败",
    },
  },
  tooltip: {
    cnCode: "CN编码由字母、数字和下划线组成，最多20个字符",
  },
  progress: {
    title: "批量计算",
    stages: {
      connecting: "连接中",
      connected: "连接完成",
      validating: "验证中",
      validated: "验证完成",
      calculating: "计算中",
      completed: "计算完成",
    },
    close: "关闭",
    regenerate: "重新生成",
    addFactor: "添加因子",
  },
  location: {
    noMatch: "无匹配结果",
    enterKeyword: "请输入关键词",
  },
  plan: {
    trialExceeded: "试用计算次数已超限 ({count})",
    trialExpired: "试用期已过期",
    monthlyExceeded: "月度计算次数已超限 ({count})",
    subscriptionExpired: "订阅期已过期",
  },
};
